module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/ripple.f3dbc363.png";